<template>
    <div class="footer-box">
        <div class="footer">
            <div class="email-box">
                <img src="../assets/logo.png" alt="">
                <p class="text-1">Subscribe</p>
                <div class="inpu-box">
                    <input type="text" placeholder="Enter your email" v-model="email">
                    <div class="btn-box" @click="onEmail">Subscribe</div>
                </div>
                <p class="text-2">By subscribing you agree to with our <span>Privacy Policy</span> </p>
            </div>
            <div class="foot-item">
                <div class="menu-box">
                    <div class="menu-item" @click="selectMenu(1)">HOME</div>
                    <div class="menu-item" @click="selectMenu(2)">CORE BUSINESS</div>
                    <div class="menu-item" @click="selectMenu(3)">ABOUT US</div>
                    <div class="menu-item" @click="selectMenu(4)">CONTACT US</div>
                </div>
                <div class="info-box">
                    <div class="info-item"><img src="../assets/tel.png" alt="">0065+48770344</div>
                    <div class="info-item"><img src="../assets/elm.png" alt="">afra@horizon-creation.com</div>
                    <div class="info-item"><img src="../assets/add.png" alt="">10 ANSON ROAD #24-11 INTERNATIONAL PLAZA SINGAPORE (079903)</div>
                </div>
            </div>
        </div>
        <div class="reserved">© 2024 Relume. All rights reserved.</div>
    </div>
</template>

<script>
export default {
    name: "footer",
    data() {
        return {
            time: '2024',
            email: ''
        };
    },
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    methods: {
        onEmail() {
            if (!this.email) {
                alert('Email cannot be empty')
            } else {
                alert('Subscription successful')
            }
        },
        selectMenu(value) {
            this.index = value
            if (value == this.step) {
                return
            }
            switch (value) {
                case 1: this.$router.push({ path: "/" }); break;
                case 2: this.$router.push({ path: "Server" }); break;
                case 3: this.$router.push({ path: "AboutUs" }); break;
                case 4: this.$router.push({ path: "ContactUs" }); break;
                default: this.$router.push({ path: "/" }); break;
            }
        }
    }
}
</script>

<style lang="less" scoped>
.footer {
    background: #F5F1EB;
    padding: 70px 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .email-box {
        img {
            height: 32px;
        }

        .text-1 {
            font-weight: 600;
            font-size: 16px;
            color: #333333;
            margin-top: 33px;
        }

        .inpu-box {
            margin-top: 16px;
            display: flex;

            input {
                width: 278px;
                height: 48px;
                padding: 0px 15px;
            }

            .btn-box {
                width: 119px;
                height: 50px;
                background: #59BA41;
                line-height: 50px;
                text-align: center;
                font-weight: 400;
                font-size: 16px;
                color: #FFFFFF;
                cursor: pointer;
            }
        }

        .text-2 {
            font-weight: 400;
            font-size: 12px;
            color: #000000;
            margin-top: 16px;
        }
    }

    .foot-item {
        width: 800px;

        .menu-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            .menu-item {
                padding: 0px 20px;
                font-weight: 400;
                font-size: 20px;
                color: rgba(51, 51, 51, 0.8);
            }
        }

        .info-box {
            display: flex;
            align-items: center;
            // justify-content: center;
            flex-wrap: wrap;

            .info-item {
                margin-top: 42px;
                margin-right: 80px;
                display: flex;
                align-items: center;

                img {
                    width: 30px 30px;
                    margin-right: 10px;
                }

                font-weight: 400;
                font-size: 24px;
                color: #333333;
            }
        }
    }
}

.reserved {
    height: 71px;
    background: #59BA41;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>